import { FormattedMessage } from 'react-intl';
import React from 'react';

const FormattedMessages = {
  bulkSendTitle: (
    <FormattedMessage
      id="Websms.bulkSendTitle"
      defaultMessage="Bulk Send"></FormattedMessage>
  ),
  bulkSendGuideTitle: (
    <FormattedMessage
      id="Websms.bulkSendGuideTitle"
      defaultMessage="Bulk Send Guide"></FormattedMessage>
  ),
  csvFile: (
    <FormattedMessage
      id="Websms.csvFile"
      defaultMessage="Upload CSV file:"></FormattedMessage>
  ),
  landingFormattingText: (
    <FormattedMessage
      id="Websms.landingFormattingText"
      defaultMessage="To send in bulk, you must first upload a .csv file."></FormattedMessage>
  ),
  landingFormattingListItem1: (
    <FormattedMessage
      id="Websms.landingFormattingListItem1"
      defaultMessage="At minimum, your file should list the mobile phone # and name of the recipients."></FormattedMessage>
  ),
  landingFormattingListItem2: (
    <FormattedMessage
      id="Websms.landingFormattingListItem2"
      defaultMessage="The file can also contain other columns of information that you might want to use to customize your message."></FormattedMessage>
  ),
  landingFormattingListItem3: (
    <FormattedMessage
      id="Websms.landingFormattingListItem3"
      defaultMessage="Your spreadsheet can have headers if you'd like, or leave them out if you'd rather."></FormattedMessage>
  ),
  landingFormattingListItem4: (
    <FormattedMessage
      id="Websms.landingFormattingListItem4"
      defaultMessage="You can add a message in one of the .csv columns or use a template that you've already saved in 'Templates' (see Building A Template below)."></FormattedMessage>
  ),
  exampleCSV: (
    <FormattedMessage
      id="Websms.exampleCSV"
      defaultMessage="example "></FormattedMessage>
  ),
  exampleCSVLink: (
    <FormattedMessage
      id="Websms.exampleCSVLink"
      defaultMessage=".csv file"></FormattedMessage>
  ),
  landingText1: (
    <FormattedMessage
      id="Websms.landingText1"
      defaultMessage="Build your template in the Template folder before preparing the send."></FormattedMessage>
  ),
  landingText2: (
    <FormattedMessage
      id="Websms.landingText2"
      defaultMessage="The template needs to be formatted with the column number (Column A=1, B=2), the number must be in brackets like this: [3]"></FormattedMessage>
  ),
  landingText3: (
    <FormattedMessage
      id="Websms.landingText3"
      defaultMessage="If I want a template that says this using the spreadsheet below:"></FormattedMessage>
  ),
  landingText4: (
    <FormattedMessage
      id="Websms.landingText4"
      defaultMessage="ex: March acct. balance: Adam has 9 tokens remaining."></FormattedMessage>
  ),
  landingText5: (
    <FormattedMessage
      id="Websms.landingText5"
      defaultMessage="My template needs to look like this:"></FormattedMessage>
  ),
  landingText6: (
    <FormattedMessage
      id="Websms.landingText6"
      defaultMessage="[3] acct. balance: [2] has [4] tokens remaining."></FormattedMessage>
  ),
  optionalMethod: (
    <FormattedMessage
      id="Websms.optionalMethod"
      defaultMessage="Optional Method"></FormattedMessage>
  ),
  optionalMethodText: (
    <FormattedMessage
      id="Websms.optionalMethodText"
      defaultMessage="If you&rsquo;d rather not add the template into CompleteSMS, you can add it into your spreadsheet. Format the message the same way, but add it to one of the columns in the spreadsheet. Then instead of selecting a template, you&rsquo;ll select which column it&rsquo;s in."></FormattedMessage>
  ),
  viewGuide: (
    <FormattedMessage
      id="Websms.viewGuide"
      defaultMessage="View File Format and Template Building Guide"></FormattedMessage>
  ),
  browseButton: (
    <FormattedMessage
      id="Websms.browseButton"
      defaultMessage="Browse"></FormattedMessage>
  ),
  mobileNumbers: (
    <FormattedMessage
      id="Websms.mobileNumbers"
      defaultMessage="Phone Number Column:"></FormattedMessage>
  ),
  recipientNames: (
    <FormattedMessage
      id="Websms.recipientNames"
      defaultMessage="Name Column:"></FormattedMessage>
  ),
  messageIn: (
    <FormattedMessage
      id="Websms.messageIn"
      defaultMessage="The message is in:"></FormattedMessage>
  ),
  csvFileColumn: (
    <FormattedMessage
      id="Websms.csvFileColumn"
      defaultMessage="CSV file's column"></FormattedMessage>
  ),
  templateRadio: (
    <FormattedMessage
      id="Websms.templateRadio"
      defaultMessage="Template"></FormattedMessage>
  ),
  templateButton: (
    <FormattedMessage
      id="Websms.templateButton"
      defaultMessage="Templates..."></FormattedMessage>
  ),
  accountStatus: (
    <FormattedMessage
      id="Websms.accountStatus"
      defaultMessage="Account status"></FormattedMessage>
  ),
  accountStatusFormat: (
    <FormattedMessage
      id="Websms.accountStatusFormat"
      defaultMessage="(period/limit/remaining/credit)"></FormattedMessage>
  ),
  updateButton: (
    <FormattedMessage
      id="Websms.updateButton"
      defaultMessage="Update"></FormattedMessage>
  ),
  startButton: (
    <FormattedMessage id="Websms.send" defaultMessage="Send"></FormattedMessage>
  ),
  sendLater: (
    <FormattedMessage
      id="Websms.sendLater"
      defaultMessage="Send SMS later"></FormattedMessage>
  ),
  totalRecipients: (
    <FormattedMessage
      id="Websms.totalRecipients"
      defaultMessage="Total recipients: "></FormattedMessage>
  ),
  validRecipients: (
    <FormattedMessage
      id="Websms.validRecipientsRecipients"
      defaultMessage="Total valid recipients: "></FormattedMessage>
  ),
  invalidRecipients: (
    <FormattedMessage
      id="Websms.invalidRecipientsRecipients"
      defaultMessage="Total invalid recipients: "></FormattedMessage>
  ),
  hashColumn: (
    <FormattedMessage
      id="Websms.hashColumn"
      defaultMessage="#"></FormattedMessage>
  ),
  recipientColumn: (
    <FormattedMessage
      id="Websms.recipientColumn"
      defaultMessage="Recipient number"></FormattedMessage>
  ),
  nameColumn: (
    <FormattedMessage
      id="Websms.nameColumn"
      defaultMessage="Recipient name"></FormattedMessage>
  ),
  messageColumn: (
    <FormattedMessage
      id="Websms.messageColumn"
      defaultMessage="Message text"></FormattedMessage>
  ),
  countColumn: (
    <FormattedMessage
      id="Websms.countColumn"
      defaultMessage="Message Parts"></FormattedMessage>
  ),
  deleteRow: (
    <FormattedMessage
      id="Websms.deleteRow"
      defaultMessage="Delete Row"></FormattedMessage>
  ),
  deleteSelectedRow: (
    <FormattedMessage
      id="Websms.deleteRow"
      defaultMessage="Delete Selected Rows"></FormattedMessage>
  ),
  modalSendTitle: (
    <FormattedMessage
      id="Websms.modalSendTitle"
      defaultMessage="Message Send Confirmation"></FormattedMessage>
  ),
  modalSendFailureTitle: (
    <FormattedMessage
      id="Websms.modalSendFailureTitle"
      defaultMessage="Cannot Send Message"></FormattedMessage>
  ),
  modalSendConfirmation: (
    <FormattedMessage
      id="Websms.modalSendConfirmation"
      defaultMessage="Do you want to send to all these recipients?"></FormattedMessage>
  ),
  modalSendPending: (
    <FormattedMessage
      id="Websms.modalSendPending"
      defaultMessage="Sending request..."></FormattedMessage>
  ),
  modalSendFailure: (
    <FormattedMessage
      id="Websms.modalSendFailure"
      defaultMessage="An error occurred with the send"></FormattedMessage>
  ),
  modalSendFailureEmptyMessages: (
    <FormattedMessage
      id="Websms.modalSendFailureEmptyMessages"
      defaultMessage="Incorrect data: Message content is empty."></FormattedMessage>
  ),
  removeHeaders: (
    <FormattedMessage
      id="Websms.removeHeaders"
      defaultMessage="Ignore the header row"></FormattedMessage>
  ),
  showInvalidRow: (
    <FormattedMessage
      id="Websms.showInvalidRow"
      defaultMessage="Show invalid rows"></FormattedMessage>
  ),
  chooseTemplateText: (
    <FormattedMessage
      id="Websms.ChooseTemplateText"
      defaultMessage="Choose a Template"></FormattedMessage>
  ),
};

export default FormattedMessages;
